import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import { FC, useEffect } from "react";
import SectionGridFilterCard from "./SectionGridFilterCard";
import { useDocumentTitle } from "hooks/useDocumentTitle";
import { useNavigate, useNavigationType } from "react-router-dom";

export interface ListingCarPageProps {
  className?: string;
}

const AvailableCarsPage: FC<ListingCarPageProps> = ({ className = "" }) => {
  useDocumentTitle("EH Rentals || Car rental");
  const navigate = useNavigate();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType === "POP") {
      navigate("/", { replace: true });
    }
  }, [navigationType, navigate]);

  return (
    <div
      className={`nc-ListingCarPage relative overflow-hidden ${className}`}
      data-nc-id="ListingCarPage"
    >
      <BgGlassmorphism />

      <div className="container relative">
        <SectionGridFilterCard className="mt-12 pb-24 lg:pb-28" />
      </div>
    </div>
  );
};

export default AvailableCarsPage;
